import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Observable, of, switchMap, take } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ConnectGuardService {

  constructor(
    private authService: AuthService,
    private router: Router) { }

  canActivate(
    route: import("@angular/router").ActivatedRouteSnapshot,
    state: import("@angular/router").RouterStateSnapshot): boolean | import("@angular/router").UrlTree | import("rxjs").Observable<boolean | import("@angular/router").UrlTree> | Promise<boolean | import("@angular/router").UrlTree> {
    return this.canActivateChild(route, state)
  }

  canActivateChild(
    route: import("@angular/router").ActivatedRouteSnapshot,
    state: import("@angular/router").RouterStateSnapshot): Observable<boolean> {

    const obs = this.authService.user$.pipe(take(1))
    return obs.pipe(
      switchMap((user: any) => {
        return of(true)
      })
    ) as Observable<boolean> 
  }
}
